import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { MediaContent, Show } from '../types/types';
import { GridCard } from './GridCard';
export const VideosGrid = ({
  mediaContent,
  selectedProgramme,
  handleBackClick,
  onVideoClick,
  selectedVideoId = null,
  theme,
  isLoading,
  hasMoreMediaContent,
  loadMoreMediaContent,
}: {
  mediaContent: MediaContent[];
  selectedProgramme: Show | null;
  handleBackClick: () => void;
  onVideoClick: (videoId: string, source: string, title: string) => void;
  selectedVideoId: string | null;
  theme: Theme;
  isLoading: boolean;
  hasMoreMediaContent: boolean;
  loadMoreMediaContent: () => void;
}) => {
  return (
    <Box sx={{ width: '100%', mt: 4 }} data-videos-grid>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton onClick={handleBackClick} sx={{ mr: 2 }}>
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            {selectedProgramme?.name || 'Search Results'}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(auto-fill, minmax(250px, 1fr))',
            md: 'repeat(auto-fill, minmax(280px, 1fr))',
            lg: 'repeat(auto-fill, minmax(300px, 1fr))',
            xl: 'repeat(auto-fill, minmax(320px, 1fr))',
          },
          gap: 3,
          width: '100%',
        }}
      >
        {mediaContent.map(video => (
          <Box key={video.id}>
            <GridCard
              title={video.title}
              isAvailable={true}
              onClick={() => onVideoClick(video.id, video.source || 'youtube', video.title)}
              selected={selectedVideoId === video.id}
              publishedAt={video.published_at}
              duration={video.duration_seconds}
              imageUrl={video.thumbnail}
            />
          </Box>
        ))}
      </Box>

      <Box
        id="load-more-trigger"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          py: 4,
        }}
      >
        {isLoading ? (
          <Typography variant="body2" color={theme.palette.text.secondary}>
            Loading more videos...
          </Typography>
        ) : hasMoreMediaContent ? (
          <Button variant="outlined" onClick={loadMoreMediaContent} sx={{ minWidth: '200px' }}>
            Load More Videos
          </Button>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};
